import preloader from "./preloader";

var members = function (container, queryOnDocumentLoad){
    let elements = $('.' + container);

    if(elements.length){
        for(let i=0; i < elements.length; i++){
            tableActions($(elements[i]), queryOnDocumentLoad);
        }
    }
}

export function tableActions(dom, queryOnDocumentLoad, sectionID){
    let timer;
    let duration = 300;
    let sort = 'default';
    let page = 1;
    let canScrollToStartTable = false;
    let onlySectionID = sectionID === undefined ? 0 : sectionID;

    if(queryOnDocumentLoad){
        query(dom);
    }

    // Sort action
    dom.find('.sort-table').on('click', function(){
        $(this).toggleClass('active');
        sort = $(this).hasClass('active') ? 'asc' : 'default';
        canScrollToStartTable = false;
        query(dom);
    })

    // Filter action
    let filterForm = dom.find('.members-filter-form');

    filterForm.find('input').on('keyup change', function(e){
        if(e.which !== undefined && e.which !== 13){
            page = 1;
            canScrollToStartTable = false;
            enableDisableButtonReset(dom);
            query(dom);
        }
    })

    filterForm.find('select').on('change', function(){
        page = 1;
        canScrollToStartTable = false;
        enableDisableButtonReset(dom);
        query(dom);
    })

    filterForm.on('submit', function(event){
        event.preventDefault();
    })

    // Reset action
    dom.find('.members-filter-reset').on('click', function(){
        filterForm.trigger('reset');
        enableDisableButtonReset(dom);
        canScrollToStartTable = false;
        query(dom);
    });

    // Enable/Disable button reset
    function enableDisableButtonReset(dom) {
        let button = dom.find('.members-filter-reset');
        let data = dom.find('.members-filter-form').serializeArray().filter(function(item){
            return item.value && item.value !== '0' && item.name !== 'limit' && item.name !== 'displaySection' && item.name !== 'type';
        });

        if(data.length){
            button.removeClass('d-none');
        }else{
            button.addClass('d-none');
        }
    }

    function initPagination(dom) {
        // Pagination action
        dom.find('.pagination a').on('click', function(){
            event.preventDefault();
            page = $(this).attr('href').split('page=')[1];
            canScrollToStartTable = true;
            query(dom);
        });
    }

    // Filter by section tab
    $(document).on('click', '.item-section', function(e){
        e.preventDefault();

        onlySectionID = $(this).data('id');
        page = 1;

        dom.removeClass('d-none');

        // Insert section detail in table
        dom.find('.name-section').html($(this).data('title'));
        dom.find('.additional-info').html('<span class="author-position">'+ $(this).data('subtitle') +'</span>')

        canScrollToStartTable = false;

        // Scroll to start table
        $('html, body').animate({
            scrollTop: dom.find('.table').offset().top-300
        }, 300);

        // Query result
        query(dom);
    });

    // Query result
    function query(dom) {
        let domItems = dom.find('.members-items');

        if(timer) clearTimeout(timer);
        timer = setTimeout(function () {
            preloader(dom, true);

            $.ajax({
                url: '/' + window.Laravel.language + '/modules/members',
                dataType: 'json',
                type: 'get',
                data: dom.find('.members-filter-form').serialize() + '&page=' + page + '&sort=' + sort + (onlySectionID ? '&section=' + onlySectionID : ''),
                success: function( response ){
                    domItems.html(response.view);

                    initPagination(dom);

                    preloader(dom, false);

                    if(canScrollToStartTable){
                        // Scroll to start table
                        $('html, body').animate({
                            scrollTop: dom.find('.table').offset().top-300
                        }, 300);
                    }

                },
                error: function( jqXhr, textStatus, errorThrown ){
                    alert( errorThrown );
                }
            });
        }, duration);
    }
}

export default members;


// WEBPACK FOOTER //
// ./resources/assets/js/functions/members.js